/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TeamsControllerUpdateMutationRequest, TeamsControllerUpdateMutationResponse, TeamsControllerUpdatePathParams, TeamsControllerUpdate400, TeamsControllerUpdate401, TeamsControllerUpdate403, TeamsControllerUpdate404 } from "../../models/teamsController/TeamsControllerUpdate";

function getTeamsControllerUpdateUrl(id: TeamsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/teams/${id}` as const }  
  return res
}

/**
 * @summary Update a team
 * {@link /api/v1/teams/:id}
 */
export async function teamsControllerUpdate(id: TeamsControllerUpdatePathParams["id"], data?: TeamsControllerUpdateMutationRequest, config: Partial<RequestConfig<TeamsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TeamsControllerUpdateMutationResponse, ResponseErrorConfig<TeamsControllerUpdate400 | TeamsControllerUpdate401 | TeamsControllerUpdate403 | TeamsControllerUpdate404>, TeamsControllerUpdateMutationRequest>({ method : "PATCH", url : getTeamsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}